import React, { useEffect } from 'react';

import { PageLayout } from '@/components/templates/PageLayout';
import { CmLongLoading, CmScrollBox } from '@/components/uiParts';
import { MenuManagementNewButtonArea } from '@/pages/menu-managements/components/TopButtonArea';
import { MenuManagementMenusForm } from '@/pages/menu-managements/menus/components/MenuManagementMenusForm';
import { useMenuManagementMenuForm } from '@/pages/menu-managements/menus/hooks/useMenuManagementMenuForm';
import { routes } from '@/router';

const MenuManagementMenusNewPage: React.FC = (): JSX.Element => {
  const {
    associateBrandSelectInput,
    titleJa,
    memo,
    error,
    searchItems,
    selectedItems,
    searchItemName,
    isSearching,
    targetsHeight,
    isLoading,
    handleCreate,
    handleInputTitleJa,
    handleInputMemo,
    handleOnDragEnd,
    handleSearchItemNameInput,
    handleAddSelectItems,
    handleDeleteDragItem,
    initializeNewPageState,
  } = useMenuManagementMenuForm();

  const isDisabledSubmitButton = [
    !error.titleJa.isTouched || error.titleJa.isError,
    error.memo.isError,
  ].some((error) => error);

  useEffect(() => {
    (async () => {
      await initializeNewPageState();
    })();
  }, []);

  return (
    <PageLayout
      title={routes.menuManagementMenusNew.title}
      {...{ associateBrandSelectInput }}
    >
      <MenuManagementNewButtonArea
        listUrl="/menu-managements/menus"
        {...{ handleCreate, isDisabledSubmitButton }}
      />
      <CmScrollBox height={`calc(100vh - ${targetsHeight}px)`}>
        <MenuManagementMenusForm
          {...{
            associateBrandSelectInput,
            titleJa,
            memo,
            isSearching,
            handleInputTitleJa,
            handleInputMemo,
            error,
            searchItems,
            selectedItems,
            handleOnDragEnd,
            searchItemName,
            handleSearchItemNameInput,
            handleAddSelectItems,
            handleDeleteDragItem,
          }}
          brandSelectValue={associateBrandSelectInput.value?.value ?? ''}
        />
      </CmScrollBox>
      {isLoading && <CmLongLoading />}
    </PageLayout>
  );
};

export default MenuManagementMenusNewPage;
